import {TranslationObject} from '@colonist/i18n'
import {LobbyImage} from '@colonist/types'
import {UIMMatchmakingController} from './UIMMatchmakingController'
import {UIMMatchmakingSearchingView} from './UIMMatchmakingSearchingView'
import {MatchmakingMatchTypes} from '@colonist/game-base-types'

type Matchmaking1v1Types = MatchmakingMatchTypes.RankedClassic1v1 | MatchmakingMatchTypes.UnrankedClassic1v1

export class UIMMatchmakingSearching1v1View extends UIMMatchmakingSearchingView<Matchmaking1v1Types> {
    constructor(matchmakingController: UIMMatchmakingController, matchType: Matchmaking1v1Types) {
        const loadingText: TranslationObject = {key: 'strings:homePage.matchmakingPopup.searchingForOpponents'}
        const isRanked = matchType == MatchmakingMatchTypes.RankedClassic1v1
        const player1v1Ranked: TranslationObject = {key: 'strings:homePage.matchmakingPopup.ranked1v1.title'}
        const player1v1Unranked: TranslationObject = {key: 'strings:homePage.unranked.1v1'}
        const title = isRanked ? player1v1Ranked : player1v1Unranked
        const imageSrc = LobbyImage.GameMode1v1

        super(matchmakingController, title, imageSrc, loadingText, matchType)
    }

    addTitle() {
        super.addTitle()
        this.setTimeElapsedCounter()
    }
}
